<template>
  <div class="push_wrapper">
    <h2>新建推送</h2>
    <Row class="push_btn_wrapper">
      <Col :span="8">
        <Upload
          class="batchImport"
          ref="upload"
          :action="baseUrl+'/basic/push/batchPush'"
          :headers="{'Access-Token':token}"
          :format="['xlsx','xls']"
          :before-upload="beforeUpload"
          :on-progress="onProgress"
          :on-error="handleError"
          :on-success="handleSuccess"
          :on-format-error="handleFormatError"
        >
          <Button type="primary" icon="ios-cloud-upload-outline">push文件导入</Button>
          <div slot="tip">
            <Button v-if="showTip" id="tip" loading>导入中...</Button>
          </div>
        </Upload>
      </Col>
      <Col :span="8" >
        <a id="download" class="ivu-btn ivu-btn-default" :href="baseUrl+'/basic/push/template/download'"><Icon type="ios-cloud-download-outline"></Icon>下载模版</a>
      </Col>
    </Row>
   </div>
</template>

<script type="text/ecmascript-6">
import { getToken } from '@/utils/auth';
import {getBaseUrl} from "@/utils/public";

export default {
  created(){
    this.getBaseUrl();
  },
  data () {
    return {
			show:false,
			loading:false,
			baseUrl:'//zyuweb.kt.ziroom.com',
			formatError: false,
			fileList:[],
			token:getToken(),
			showTip:false
    };
  },
  methods: {
    cancel(){
      this.show = false
    },
    handleSuccess(response, file,fileList){
      this.fileList = fileList
      if(response.code===0){
				this.$Message.success('导入成功')
      }else {
        this.$refs.upload.handleRemove(file)
        this.$Message.error('导入失败,'+response.message)
      }
      this.fileList=[]
      this.$refs.upload.clearFiles()
      this.showTip=false
    },
    beforeUpload(file){
      if (this.fileList.length && this.fileList.find( item => {
        return item.name === file.name
      })){
         this.$Message.error('不能上传重复文件');
        return false
      }
    },
    handleFormatError() {
      this.$Message.error('请上传excel文件')
    },
    handleError() {
      console.log('error')
    },
    onProgress(){
      this.showTip=true
    },
    getBaseUrl(){
      this.baseUrl=getBaseUrl()
    }
 }
}
</script>

<style lang="css" scoped>
  #download  i{
    padding-right: 4px;
  }
  #tip {
    margin-top:2px;
    border-width:0px;
    background: transparent;
    padding: 0
  }
  .push_wrapper{
    position: relative;
    padding-top: 0;margin-left:26px;margin-top:30px;
  }
  .push_btn_wrapper{
    width: 500px;
    margin-top: 50px;
  }

</style>
